<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 col-sm-12 bg-white shadow-sm rounded-lg border mb-5">
                <form class="m-3" @submit.prevent="submit">
                    <div id="error-message" class="small alert alert-danger" style="display: none; color: #721c24;background-color: #f8d7da;border-color: #f5c6cb;">
                            {{ trans.validation_error_message }}
                        </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.title }}</label>
                        <div class="col-sm-9">
                            <input
                                type="text"
                                class="form-control"
                                maxlength="150"
                                v-model="fields.title"
                            />
                            <small class="form-text text-muted">
                                {{ trans.title_150_characters }}
                            </small>
                            <span class="text-danger" v-if="errors && errors.title">
                                {{ errors.title[0] }}
                            </span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputPassword" class="col-sm-3 col-form-label">{{
                            trans.sub_title
                        }}</label>
                        <div class="col-sm-9">
                            <input
                                type="text"
                                class="form-control"
                                maxlength="100"
                                v-model="fields.sub_title"
                            />
                            <small class="form-text text-muted">
                                {{ trans.help_text.sub_title }}
                            </small>
                            <span class="text-danger" v-if="errors && errors.sub_title">
                                {{ errors.sub_title[0] }}
                            </span>
                        </div>
                    </div>
                    <!-- Logo -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.logo }}</label>
                        <div class="col-sm-8">
                            <label for="logoFile" role="button">
                                <img
                                    class="logo-size-100"
                                    id="preview-logo"
                                    ref="logo"
                                    style="width: 52px; height: 52px;"
                                    :src="formData ? formData.logo_url : '/img/no-image.jpg'"
                                >
                            </label>
                            <span class="align-top text-danger"
                                type="button"
                                @click="removeLogo()"
                                v-if="fields.logo"
                            >
                                <i class="fas fa-minus-circle fa-lg"></i>
                            </span>
                            <input class="form-control-file d-none"
                                id="logoFile"
                                type="file"
                                accept=".jpeg, .png, .jpg"
                                @change="uploadLogo">
                            <small class="form-text text-muted">
                                {{ trans.help_text.logo }}
                            </small>
                            <!-- error -->
                            <span class="form-text text-danger"
                                v-if="errors && errors.logo"
                            >
                                {{ errors.logo[0] }}
                            </span>
                        </div>
                    </div>
                    <!-- Show title or logo -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.header_type }}
                        </label>
                        <div class="col-sm-8 my-2">
                            <div class="form-check form-check-inline">
                                <input type="radio" id="showTitle" class="form-check-input" value="1" v-model="fields.header_type">
                                <label for="showTitle" class="form-check-label">{{ trans.title }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="showLogo" class="form-check-input" value="2" v-model="fields.header_type">
                                <label for="showLogo" class="form-check-label">{{ trans.logo }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="showTitleAndLogo" class="form-check-input" value="3" v-model="fields.header_type">
                                <label for="showTitleAndLogo" class="form-check-label">{{ trans.title_and_logo }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" id="noShowTitleLogo" class="form-check-input" value="0" v-model="fields.header_type">
                                <label for="noShowTitleLogo" class="form-check-label">{{ trans.none }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row" v-show="isWsAdmin">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.mapbox_token }}<span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="text"
                                class="form-control"
                                v-model.lazy="fields.mapbox_token"
                            />
                            <small class="form-text text-muted">
                                {{ trans.help_text.map_token }}
                            </small>
                            <span class="small px-2 py-1 bg-success rounded">Can only be set by WS Admin(WSAdminのみ設定可)</span>
                            <span class="text-danger" v-if="errors && errors.mapbox_token">
                                {{ errors.mapbox_token[0] }}
                            </span>
                        </div>
                    </div>
                    <div class="form-group row" v-if="tokenIsValid">
                        <div
                            class="btn-group"
                            role="group"
                            aria-label="Basic example"
                            style="white-space: nowrap;"
                            v-if="fields.switch_language"
                        >
                            <button
                                type="button"
                                class="btn btn-xs btn-default"
                                v-for="langCode in fields.languages"
                                :key="langCode"
                                @click="$refs.mySmartMap.switchLanguage(langCode)"
                            >
                                {{ mapLanguages[langCode] }}
                            </button>
                        </div>

                        <map-preview
                            ref="mySmartMap"
                            :zoom-level="fields.zoom_level"
                            :access-token="fields.mapbox_token"
                            :apply-locate-user="fields.apply_locate_user"
                            :show-fullscreen="fields.show_fullscreen"
                            :coordinates="[fields.lng, fields.lat]"
                            :map-style="fields.style"
                            :has-marker="true"
                            :draggable="true"
                            :min-zoom="fields.min_zoom"
                            :max-zoom="fields.max_zoom"
                            :pitch="fields.pitch"
                            :bearing="fields.bearing"
                            :cooperative-gestures="fields.cooperative_gestures"
                            :bounds="
                                fields.apply_max_bounds
                                    ? [
                                          [96.1102, 9.1882],
                                          [182.0182, 53.4576]
                                      ]
                                    : null
                            "
                            :marker-coordinates="[fields.lng, fields.lat]"
                            @updatedMarkerCoordinates="changeMarkerCoordinates"
                            :admin-lang="adminLang"
                        >
                        </map-preview>
                    </div>
                    <hr>
                    <div class="text-muted">{{ trans.starting_setting }}</div>
                    <div class="small mb-4 text-muted">{{ trans.starting_setting_sub }}</div>
                    <div class="form-group row de-flex">
                        <label for="inputPassword" class="col-sm-3 col-form-label">{{
                            trans.starting_position
                        }}</label>
                        <div class="ml-2">
                            <span>{{ trans.latitude }}</span>
                            <input
                                type="number"
                                min="-90"
                                max="90"
                                step="any"
                                class="form-control"
                                v-model="fields.lat"
                            />
                            <span class="text-danger" v-if="errors && errors.lat">{{
                                errors.lat[0]
                            }}</span>
                        </div>
                        <div class="ml-2">
                            <span>{{ trans.longtitude }}</span>
                            <input
                                type="number"
                                min="-180"
                                max="180"
                                step="any"
                                class="form-control"
                                v-model="fields.lng"
                            />
                            <span class="text-danger" v-if="errors && errors.lng">{{
                                errors.lng[0]
                            }}</span>
                        </div>
                        <div class="">
                            <span>&nbsp;</span>
                            <button
                                class="btn btn-outline-primary btn-block ml-2"
                                @click="$refs.mySmartMap.changeStartingPosition()"
                                type="button"
                                :disabled="!tokenIsValid"
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                    <!-- Starting Zoom -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.starting_zoom }}</label>
                        <div class="col-sm-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button
                                        class="btn btn-secondary"
                                        type="button"
                                        @click="changeZoomLevel(-0.25)"
                                    >
                                        -
                                    </button>
                                    <button
                                        class="btn btn-dark"
                                        type="button"
                                        @click="changeZoomLevel(0.25)"
                                    >
                                        +
                                    </button>
                                </div>
                                <input
                                    type="text"
                                    class="form-control text-center"
                                    :value="fields.zoom_level"
                                    ref="zoomLevel"
                                    disabled="disabled"
                                />
                                <span class="text-danger" v-if="errors && errors.zoom_level">
                                    {{ errors.zoom_level[0] }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="text-muted">{{ trans.marker_setting }}</div>
                    <div class="small mb-4 text-muted">{{ trans.marker_setting_sub }}</div>
                    <!-- Zoom Range  -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.zoom_range }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                min="0"
                                max="22"
                                v-model.number="fields.location_zoom_range[0]"
                                step="0.25"
                            />
                            <span class="text-danger" v-if="errors.hasOwnProperty('location_zoom_range.0')">
                                {{ errors['location_zoom_range.0'][0] }}
                            </span>
                            <small class="form-text text-muted">
                                {{ trans.help_text.zoomlevel }}
                            </small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{trans.show_cluster}}
                        </label>
                        <div class="col-sm-9">
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="clusterSwitch"
                                    v-model="fields.show_cluster"
                                />
                                <label class="custom-control-label" for="clusterSwitch"></label>
                                <span class="text-danger" v-if="errors && errors.show_cluster">{{
                                    errors.show_cluster[0]
                                }}</span>
                            </div>
                            <small class="form-text text-muted">
                                {{ trans.cluster_sub }}
                            </small>
                        </div>
                    </div>
                    <hr>
                    <div class="text-muted">{{ trans.tooltip_setting }}</div>
                    <div class="small mb-4 text-muted">{{ trans.tooltip_setting_sub }}</div>
                    <!-- Display Tooltip -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.show_tooltip }}
                        </label>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="custom-control custom-switch">
                                        <input
                                        type="checkbox"
                                        id="showTooltipSwitch"
                                        class="custom-control-input"
                                        v-model="fields.show_tooltip"
                                        >
                                        <label for="showTooltipSwitch" class="custom-control-label"></label>
                                    </div>
                                    <span class="text-danger" v-if="errors && errors.show_tooltip">{{
                                        errors.show_tooltip[0]
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Tooltip Zoom -->
                    <div class="form-group row" v-if="fields.show_tooltip">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.tooltip_zoom }}
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                min="0"
                                max="22"
                                step="0.25"
                                v-model.number="fields.tooltip_zoom"
                            />
                            <span class="text-danger" v-if="errors && errors.tooltip_zoom">{{
                                errors.tooltip_zoom[0]
                            }}</span>
                            <small class="form-text text-muted">
                                {{ trans.help_text.zoomlevel }}
                            </small>
                        </div>
                    </div>
                    <!-- Tooltip Title -->
                    <div class="form-group row" v-if="fields.show_tooltip">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.tooltip_title_zoom }}
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                min="0"
                                max="22"
                                step="0.25"
                                v-model.number="fields.tooltip_title_zoom"
                            />
                            <span class="text-danger" v-if="errors && errors.tooltip_title_zoom">{{
                                errors.tooltip_title_zoom[0]
                            }}</span>
                            <small class="form-text text-muted">
                                {{ trans.tooltip_title_zoom_help }}
                            </small>
                        </div>
                    </div>
                    <hr>
                    <div class="mb-3 text-muted">{{ trans.map_display_setting }}</div>
                    <!-- min zoom -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.min_zoom }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                min="0"
                                max="22"
                                step="0.25"
                                v-model.number="fields.min_zoom"
                            />
                            <span class="text-danger" v-if="errors && errors.min_zoom">{{
                                errors.min_zoom[0]
                            }}</span>
                            <small class="form-text text-muted">
                                {{ trans.zoom_min_sub }}
                            </small>
                        </div>
                    </div>
                    <!-- max zoom -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.max_zoom }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                min="0"
                                max="22"
                                step="0.25"
                                v-model.number="fields.max_zoom"
                            />
                            <span class="text-danger" v-if="errors && errors.max_zoom">{{
                                errors.max_zoom[0]
                            }}</span>
                            <small class="form-text text-muted">
                                {{ trans.zoom_max_sub }}
                            </small>
                        </div>
                    </div>
                    <!-- pitch -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.pitch }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                v-model.number="fields.pitch"
                            />
                            <span class="text-danger" v-if="errors && errors.pitch">{{
                                errors.pitch[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- bearing -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.bearing }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                v-model.number="fields.bearing"
                            />
                            <span class="text-danger" v-if="errors && errors.bearing">{{
                                errors.bearing[0]
                            }}</span>
                        </div>
                    </div>
                    <hr>
                    <div class="text-muted">{{ trans.custom_setting }}</div>
                    <div class="small mb-4 text-muted">{{ trans.custom_setting_sub }}</div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.customize }}</label>
                        <div class="col-sm-9">
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="geocoderSwitch"
                                    v-model="fields.apply_geocoder"
                                />
                                <label class="custom-control-label" for="geocoderSwitch">{{
                                    trans.add_geocoder
                                }}</label>
                                <span class="text-danger" v-if="errors && errors.apply_geocoder">{{
                                    errors.apply_geocoder[0]
                                }}</span>
                            </div>
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="locateSwitch"
                                    v-model="fields.apply_locate_user"
                                />
                                <label class="custom-control-label" for="locateSwitch">{{
                                    trans.locate_user
                                }}</label>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.apply_locate_user"
                                    >{{ errors.apply_locate_user[0] }}</span
                                >
                                <small class="form-text text-muted m-0 mb-2">
                                    {{ trans.apply_locate_user_sub }}
                                </small>
                            </div>
                            <!-- if client request, ON ----
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="fullscreenSwitch"
                                    v-model="fields.show_fullscreen"
                                />
                                <label class="custom-control-label" for="fullscreenSwitch">{{
                                    trans.view_fullscreen
                                }}</label>
                                <span class="text-danger" v-if="errors && errors.show_fullscreen">{{
                                    errors.show_fullscreen[0]
                                }}</span>
                            </div>
                            -->

                            <!-- cooperative_gestures -->
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="cooperativeGestureSwitch"
                                    v-model="fields.cooperative_gestures"
                                />
                                <label
                                    class="custom-control-label"
                                    for="cooperativeGestureSwitch"
                                    >{{ trans.cooperative_gestures }}</label
                                >
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.cooperative_gestures"
                                    >{{ errors.cooperative_gestures[0] }}</span
                                >
                                <small class="form-text text-muted m-0 mb-2">
                                    {{ trans.cooperative_gestures_sub }}
                                </small>
                            </div>
                            <!-- apply max bounds -->
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="applyMaxBoundsSwitch"
                                    v-model="fields.apply_max_bounds"
                                />
                                <label class="custom-control-label" for="applyMaxBoundsSwitch">{{
                                    trans.apply_max_bounds
                                }}</label>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.apply_max_bounds"
                                    >{{ errors.apply_max_bounds[0] }}</span
                                >
                                <small class="form-text text-muted m-0 mb-2">
                                    {{ trans.apply_max_bounds_sub }}
                                </small>
                            </div>
                            <!-- window open _blank -->
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="newTabSwitch"
                                    v-model="fields.show_new_tab"
                                />
                                <label class="custom-control-label" for="newTabSwitch">{{
                                    trans.open_new_tab
                                }}</label>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.show_new_tab"
                                    >{{ errors.show_new_tab[0] }}</span
                                >
                                <small class="form-text text-muted m-0 mb-2">
                                    {{ trans.show_new_tab_sub }}
                                </small>
                            </div>
                            <!-- switch base map -->
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="baseMapSwitch"
                                    v-model="fields.show_floor_map"
                                />
                                <label class="custom-control-label" for="baseMapSwitch">{{ trans.hide_floor_park_map }}</label>
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.show_floor_map"
                                    >{{ errors.show_floor_map[0] }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="text-muted">{{ trans.map_language_setting }}</div>
                    <div class="small mb-4 text-muted">{{ trans.map_language_setting_sub }}</div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label"
                            >{{ trans.default_language }}<span class="required-star"></span
                        ></label>
                        <div class="col-sm-4">
                            <select class="form-control" v-model="fields.default_language">
                                <option
                                    :value="langCode"
                                    v-for="(langTxt, langCode) in mapLanguages"
                                    :key="langCode"
                                >
                                    {{ mapLanguages[langCode] }}
                                </option>
                            </select>
                            <span
                                class="d-block text-danger"
                                v-if="errors && errors.default_language"
                                >{{ errors.default_language[0] }}</span
                            >
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{trans.switch_language}}</label>
                        <div class="col-sm-9">
                            <div class="custom-control custom-switch mb-2">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="languageSwitch"
                                    v-model="fields.switch_language"
                                />
                                <label class="custom-control-label" for="languageSwitch"></label>
                                <span class="text-danger" v-if="errors && errors.switch_language">{{
                                    errors.switch_language[0]
                                }}</span>
                            </div>
                            <div
                            v-show="fields.switch_language"
                                class="form-check form-check-inline"
                                v-for="(langTxt, langCode) in mapLanguages"
                                :key="langCode"
                            >
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="fields.languages"
                                    :value="langCode"
                                    :id="langCode + 'Check'"
                                />
                                <label class="form-check-label" :for="langCode + 'Check'">{{
                                    langTxt
                                }}</label>
                            </div>
                            <span class="d-block text-danger" v-if="errors && errors.languages">{{
                                errors.languages[0]
                            }}</span>
                             <small class="form-text text-muted">
                                {{ trans.your_browser_language_sub }}
                            </small>
                        </div>
                    </div>
                    <hr>
                    <div class="text-muted">{{ trans.design_setting }}</div>
                    <div class="small mb-4 text-muted">{{ trans.design_setting_sub }}</div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.choose_map_style }}
                        </label>
                        <div class="col-sm-8">
                            <div
                                class="form-check form-check-inline"
                                v-for="(styleVal, styleKey) in mapStyles"
                                :key="styleKey"
                            >
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    v-model="selectMapStyle"
                                    :value="styleKey"
                                    :id="styleKey + 'Check'"
                                />
                                <label class="form-check-label" :for="styleKey + 'Check'">{{
                                    styleKey
                                }}</label>
                            </div>
                            <input
                                v-if="selectMapStyle == 'custom'"
                                type="text"
                                class="form-control mt-2"
                                v-model="fields.style"
                            />
                            <small class="form-text text-muted">
                                {{ trans.help_text.map_style }}
                            </small>
                            <span class="d-block text-danger" v-if="errors && errors.style">{{
                                errors.style[0]
                            }}</span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.theme_color }}
                        </label>
                        <div class="col-sm-2">
                            <select class="form-control" v-model="fields.theme_color">
                                <option
                                    v-for="(theme, index) in themes"
                                    :value="theme"
                                    :key="'theme-' + index"
                                >
                                    {{ theme }}
                                </option>
                            </select>
                            <span class="d-block text-danger" v-if="errors && errors.theme_color">
                                {{ errors.theme_color[0] }}
                            </span>
                        </div>
                        <div class="col-sm-2 align-self-center">
                            <a href="/maps/preview?colorthemeset=1" target="_blank" rel="noopener">Sample
                            </a>
                        </div>
                    </div>
                    <!-- tile layer -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.tile_layer }}</label>
                        <div class="col-sm-9">
                            <input
                                type="text"
                                class="form-control"
                                v-model="fields.tile_layer"
                            />
                            <small class="form-text text-muted">
                                {{ trans.tile_layer_help }}
                            </small>
                            <span class="text-danger" v-if="errors && errors.tile_layer">
                                {{ errors.tile_layer[0] }}
                            </span>
                        </div>
                    </div>
                    <hr>
                    <div class="text-muted">{{ trans.contents_setting }}</div>
                    <div class="small mb-4 text-muted">{{ trans.contents_setting_sub }}</div>
                    <!-- default locale -->
                    <div class="form-group row" v-show="isWsAdmin">
                        <label class="col-sm-3 col-form-label"
                            >{{ trans.choose_default_locale }}<span class="required-star"></span
                        ></label>
                        <div class="col-sm-6">
                            <select class="form-control" v-model="fields.default_locale">
                                <option
                                    :value="localeCode"
                                    v-for="(localeTxt, localeCode) in trans.locales"
                                    :key="localeCode"
                                >
                                    {{ localeTxt }}
                                </option>
                            </select>
                            <div class="small px-2 py-1 bg-success rounded mt-2 w-fit">Can only be set by WS Admin(WSAdminのみ設定可)</div>
                            <span class="d-block text-danger" v-if="errors && errors.locales">{{
                                errors.locales[0]
                            }}</span>
                        </div>
                    </div>
                    <div>
                        <!-- additional locales -->
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">{{
                                trans.is_multi_localization
                            }}</label>
                            <div class="col-sm-9">
                                <!-- is multi locale -->
                                <div class="custom-control custom-switch mb-2">
                                    <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="isMultiLocaleSwitch"
                                        v-model="fields.is_multi_localization"
                                    />
                                    <label class="custom-control-label" for="isMultiLocaleSwitch"></label>
                                    <span
                                        class="text-danger"
                                        v-if="errors && errors.is_multi_localization"
                                        >{{ errors.is_multi_localization[0] }}</span
                                    >
                                </div>
                                <div v-show="fields.is_multi_localization"
                                    class="form-check form-check-inline"
                                    v-for="(localeTxt, localeCode) in trans.locales"
                                    :key="localeCode"
                                >
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="fields.locales"
                                        :value="localeCode"
                                        :id="localeCode + 'CheckLocale'"
                                    />
                                    <label
                                        class="form-check-label"
                                        :for="localeCode + 'CheckLocale'"
                                        >{{ localeTxt }}</label
                                    >
                                </div>
                                <span class="d-block text-danger" v-if="errors && errors.locales">{{
                                    errors.locales[0]
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- auto switch browser language -->
                    <div class="form-group row" v-if="fields.is_multi_localization">
                        <label class="col-sm-3 col-form-label">{{
                            trans.auto_switch_browser_language
                        }}
                        </label>
                        <div class="col-sm-9">
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="useBrowserLanguageSwitch"
                                    v-model="fields.use_browser_language"
                                />
                                <label class="custom-control-label" for="useBrowserLanguageSwitch"></label>
                                <span class="text-danger" v-if="errors && errors.use_browser_language">{{
                                    errors.use_browser_language[0]
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.default_marker_image }}</label>
                        <div class="col-sm-8">
                            <label for="defaultMarkerImageFile" role="button">
                                <img
                                    class="icon-size-100"
                                    ref="default_marker_image"
                                    id="preview-defaul-marker-image"
                                    style="width: 52px; height: 52px;"
                                    :src="formData ? formData.default_marker_image_url : '/img/no-image.jpg'"
                                >
                            </label>
                            <span class="align-top text-danger remove-btn"
                                type="button"
                                @click="removeImage()"
                                field-name="default_marker_image"
                                preview-id="preview-defaul-marker-image"
                                v-if="fields.default_marker_image"
                            >
                                <i class="fas fa-minus-circle fa-lg"></i>
                            </span>
                            <input class="form-control-file d-none"
                                id="defaultMarkerImageFile"
                                type="file"
                                accept=".jpeg, .png, .jpg"
                                @change="uploadImage"
                                field-name="default_marker_image"
                                preview-id="preview-defaul-marker-image">
                            <small class="form-text text-muted">
                                {{ trans.default_marker_image_size }}
                            </small>
                            <!-- error -->
                            <p
                                class="text-danger"
                                v-if="errors && errors.default_marker_image"
                            >{{ errors.default_marker_image[0] }}</p>
                        </div>
                    </div>
                    <div class="form-group row" v-show="isWsAdmin">
                        <label class="col-sm-3 col-form-label">{{
                            trans.auto_translate
                        }}</label>
                        <div class="col-sm-9 align-self-center">
                            <div class="form-check form-check-inline">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="fields.use_auto_translate"
                                />
                            </div>
                            <div class="small px-2 py-1 bg-success rounded w-fit">Can only be set by WS Admin(WSAdminのみ設定可)</div>
                            <span class="d-block text-danger" v-if="errors && errors.use_auto_translate">{{
                                errors.use_auto_translate[0]
                            }}</span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{
                            trans.hide_near_spots
                        }}</label>
                        <div class="col-sm-9 align-self-center">
                            <div class="form-check form-check-inline">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="fields.hide_near_spots"
                                />
                            </div>
                            <small class="form-text text-muted">
                                {{ trans.help_near_spots }}
                            </small>
                            <span class="d-block text-danger" v-if="errors && errors.hide_near_spots">{{
                                errors.hide_near_spots[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- sidenavi Banner&link -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.banner }}</label>
                        <div class="col-sm-8">
                            <div class="d-flex">
                                <div style="width: 130px;">
                                    <label for="bannerFile" role="button">
                                        <img
                                            class="banner-size-100"
                                            id="preview-banner"
                                            ref="banner"
                                            style="width: 52px; height: 52px;"
                                            :src="formData && formData.banner_url ? formData.banner_url : '/img/no-image.jpg'"
                                        >
                                    </label>
                                    <span class="align-top text-danger"
                                        type="button"
                                        @click="removeBanner()"
                                        v-if="fields.banner"
                                    >
                                        <i class="fas fa-minus-circle fa-lg"></i>
                                    </span>
                                    <input class="form-control-file d-none"
                                        id="bannerFile"
                                        type="file"
                                        accept=".jpeg, .png"
                                        @change="uploadBanner">
                                    <!-- error -->
                                    <span class="form-text text-danger"
                                        v-if="errors && errors.banner"
                                    >
                                        {{ errors.banner[0] }}
                                    </span>
                                </div>
                                <div class="w-100 py-2">
                                    <input
                                        type="text"
                                        class="form-control"
                                        maxlength="100"
                                        v-model="fields.banner_link"
                                        placeholder="https://"
                                    />
                                    <span class="text-danger" v-if="errors && errors.banner_link">
                                        {{ errors.banner_link[0] }}
                                    </span>
                                </div>
                            </div>
                            <small class="form-text text-muted">
                                {{ trans.default_marker_image_size }}
                            </small>
                        </div>
                    </div>
                    <div v-if="isWsAdmin">
                        <div class="form-group row">
                            <label class="col-sm-3 col-form-label">{{ trans.no_use_main_map }}</label>
                            <div class="col-sm-9 align-self-center">
                                <div class="form-check form-check-inline">
                                    <input type="checkbox" class="form-check-input" v-model="fields.no_use_main_map">
                                </div>
                                <div class="small px-2 py-1 bg-success rounded w-fit">Can only be set by WS Admin(WSAdminのみ設定可)</div>
                            </div>
                        </div>
                        <div class="form-group row" v-if="fields.no_use_main_map">
                            <label class="col-sm-3 col-form-label">{{ trans.redirect_floor_map }}</label>
                            <div class="col-sm-4">
                                <select class="form-control" v-model="fields.redirect_to_parcel_id">
                                    <option
                                        v-for="(parcel, index) in formData.parcels"
                                        :value="parcel.id" :key="index"
                                        :selected="fields.redirect_to_parcel_id == parcel.id"
                                    >
                                        {{ parcel.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.show_image_category }}</label>
                        <div class="col-sm-9">
                            <div class="form-check form-check-inline">
                                <input type="checkbox" class="form-check-input" v-model="fields.show_image_category">
                            </div>
                            <span class="text-danger" v-if="errors && errors.show_image_category">
                                {{ errors.show_image_category[0] }}
                            </span>
                            <small class="form-text text-muted">
                                {{ trans.show_image_category_help }}
                            </small>
                        </div>
                    </div>
                    <hr>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.attribution_license }}</label>
                        <div class="col-sm-9">
                            <textarea
                                class="form-control col-sm-12 code-textarea"
                                rows="20"
                                v-model="fields.attribution_license"
                            ></textarea>
                            <span class="text-danger" v-if="errors && errors.attribution_license">
                                {{ errors.attribution_license[0] }}
                            </span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.custom_style_script }}
                        </label>
                        <div class="col-sm-9">
                            <div class="form-group">
                                <label class="col-sm-12 mb-1">{{ trans.header }}</label>
                                <textarea
                                    class="form-control col-sm-12 code-textarea"
                                    rows="20"
                                    v-model="fields.custom_style_script_header"
                                ></textarea>
                                <span
                                    class="d-block text-danger"
                                    v-if="errors && errors.custom_style_script_header"
                                >
                                    {{ errors.custom_style_script_header[0] }}
                                </span>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-12 mb-1">{{ trans.body }}</label>
                                <textarea
                                    class="form-control col-sm-12 code-textarea"
                                    rows="20"
                                    v-model="fields.custom_style_script_body"
                                ></textarea>
                                <span
                                    class="d-block text-danger"
                                    v-if="errors && errors.custom_style_script_body"
                                >
                                    {{ errors.custom_style_script_body[0] }}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="form-group">
                    <button class="btn btn-primary w-25 center mb-4 mt-4 float-right submit-btn">
                        {{ trans.submit_btn }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MapPreview from './MapPreview';
import axios from 'axios';
import CheckAccessToken from '../mixins/MapBox/CheckAccessToken';

export default {
    mixins: [CheckAccessToken],
    components: {
        MapPreview
    },
    props: {
        formData: {
            type: Object,
            default: null
        },
        formAction: {
            type: String,
            required: true
        },
        trans: {
            type: Object,
            required: true
        },
        isWsAdmin: {
            type: Boolean,
            default: false
        },
        themes: {
            type: Array,
            required: true
        },
        locales: {
            type: Array,
            required: true
        },
        adminLang: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            containerId: 'map',
            mapLanguages: {
                browser: 'Your browser language',
                en: 'English',
                ja: 'Japanese',
                'zh-Hans': 'Chinese Simplified',
                'zh-Hant': 'Chinese Traditional',
                ko: 'Korean',
                fr: 'French',
                de: 'German',
                it: 'Italian',
                pt: 'Portuguese',
                ru: 'Russian',
                es: 'Spanish',
                ar: 'Arabic'
            },
            mapStyles: {
                streets: 'mapbox://styles/mapbox/streets-v11',
                light: 'mapbox://styles/mapbox/light-v10',
                dark: 'mapbox://styles/mapbox/dark-v10',
                outdoors: 'mapbox://styles/mapbox/outdoors-v11',
                satellite: 'mapbox://styles/mapbox/satellite-v9',
                custom: ''
            },
            selectMapStyle: '',
            fields: {
                title: '',
                sub_title: '',
                mapbox_token:
                    'pk.eyJ1IjoiZGVtb3dvcmxkd2lkZXN5c3RlbSIsImEiOiJja3M0MzZ1YTIxN3ljMzBxbWllaGIyNGRkIn0.0NFRKaTM7LgbAmJ8F4avoQ',
                languages: [],
                lng: 139,
                lat: 35,
                zoom_level: 4,
                min_zoom: 0,
                max_zoom: 22,
                pitch: 0,
                bearing: 0,
                cooperative_gestures: false,
                apply_max_bounds: false,
                apply_geocoder: false,
                apply_locate_user: false,
                show_cluster: false,
                show_fullscreen: false,
                switch_language: false,
                default_language: '',
                is_multi_localization: false,
                default_locale: '',
                locales: [],
                show_category: false,
                show_compass: false,
                show_zoom: false,
                style: '',
                theme_color: 'light',
                location_zoom_range: [0, 22],
                custom_style_script_header: '',
                custom_style_script_body: '',
                show_new_tab: false,
                logo: null,
                header_type: 1,
                remove_logo: false,
                tooltip_zoom: 0,
                tooltip_title_zoom: 0,
                show_tooltip: false,
                remove_default_marker_image: false,
                default_marker_image: null,
                hide_near_spots: false,
                use_auto_translate: false,
                banner: null,
                remove_banner: false,
                banner_link: '',
                use_browser_language: false,
                no_use_main_map: false,
                redirect_to_parcel_id: null,
                tile_layer: '',
                show_floor_map: false,
                attribution_license: '',
                show_image_category: true,
            },
            errors: {}
        };
    },
    methods: {
        prepareFormData() {
            let formData = new FormData();
            for (const key in this.fields) {
                if (key === 'logo' || key === 'default_marker_image' || key === 'banner') {
                    continue;
                }
                formData.append(key, this.fields[key]);
            }
            formData.append('language', JSON.stringify(this.fields.languages));
            formData.append('locales', JSON.stringify(this.fields.locales));
            formData.append('header_type', JSON.stringify(this.fields.header_type ?? 1));
            formData.append('location_zoom_range', JSON.stringify(this.fields.location_zoom_range));
            formData.append('tooltip_zoom', JSON.stringify(this.fields.tooltip_zoom));
            formData.append('tooltip_title_zoom', JSON.stringify(this.fields.tooltip_title_zoom));
            formData.append('banner_link', JSON.stringify(this.fields.banner_link));
            formData.append('redirect_to_parcel_id', JSON.stringify(this.fields.redirect_to_parcel_id));
            formData.append('tile_layer', JSON.stringify(this.fields.tile_layer));

            if (this.fields.logo instanceof File) {
                formData.append("logo", this.fields.logo);
            }
            if (this.fields.default_marker_image instanceof File) {
                formData.append('default_marker_image', this.fields.default_marker_image);
            }
            if (this.fields.banner instanceof File) {
                formData.append("banner", this.fields.banner);
            }
            if (this.formData) {
                formData.append("_method", "PUT");
            }
            return formData;
        },
        submit() {
            this.appendDefaultLocaleToLocales();
            axios({
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                method: 'post',
                url: this.formAction,
                data: this.prepareFormData()
            })
                .then((response) => {
                    toastr["success"](response.data.message);
                    if (response.data.redirectTo != undefined) {
                        window.location.replace(response.data.redirectTo);
                    } else {
                        location.reload();
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.errors = error.response.data.errors;
                    }
                    document.getElementById('error-message').style.display = 'block';
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                });
        },
        fetch(mapData) {
            for (const key in this.fields) {
                if (key === 'remove_logo' || key === 'remove_default_marker_image' || key === 'remove_banner') {
                    continue;
                }
                if (!mapData.hasOwnProperty(key)) {
                    alert('Have no ' + key + ' key when fetching data');
                    window.history.back();
                }
                this.fields[key] = mapData[key];
            }
            if (!this.fields.tooltip_zoom) {
                this.fields.tooltip_zoom = 0;
            }
            if (!this.fields.tooltip_title_zoom) {
                this.fields.tooltip_title_zoom = 0;
            }
            var isCustomStyle = true;
            for (const key in this.mapStyles) {
                const style = this.mapStyles[key];
                if (mapData.style == style) {
                    isCustomStyle = false;
                    this.selectMapStyle = key;
                }
            }
            if (isCustomStyle) {
                this.mapStyles.custom = mapData.style;
                this.selectMapStyle = 'custom';
            }
        },
        changeZoomLevel(payload) {
            payload = payload ? this.fields.zoom_level + payload : this.$refs.zoomLevel.value;
            if (payload < 0 || payload > 22) {
                alert('The zoom level can not be less than 0 OR greater 23');
                return;
            }
            this.fields.zoom_level = parseFloat(payload);
        },
        changeMarkerCoordinates(val) {
            this.fields.lng = val[0];
            this.fields.lat = val[1];
        },
        appendDefaultLocaleToLocales() {
            var result = [this.fields.default_locale];
            this.fields.locales.forEach((locale) => {
                if (locale && locale != this.fields.default_locale) {
                    result.push(locale);
                }
            });

            this.fields.locales = result;
        },
        uploadLogo(e) {
            const file = e.target.files[0];

            if (!file || !file.type.match(/.(jpg|jpeg|png)$/i)) return;

            let previewLogo = document.getElementById("preview-logo");
            previewLogo.src = URL.createObjectURL(file);
            this.fields.logo = file;
            this.fields.remove_logo = false;
        },
        removeLogo() {
            this.$refs.logo.src = "/img/no-image.jpg";
            this.fields.logo = null;
            if(this.formData) {
                this.fields.remove_logo = true;
            }
        },
        uploadImage(event) {
            const file = event.target.files[0];
            if (!file || !file.type.match(/.(jpg|jpeg|png|svg\+xml)$/i)) return;

            let previewImage = document.getElementById(event.target.getAttribute('preview-id'));
            previewImage.src = URL.createObjectURL(file);
            var fieldName = event.target.getAttribute('field-name');
            this.fields[fieldName] = file;
            this.fields['remove_' + fieldName] = false;
        },
        removeImage() {
            let previewImage = document.getElementById((event.target.closest('.remove-btn')).getAttribute('preview-id'));
                previewImage.src = "/img/no-image.jpg";
            var fieldName = (event.target.closest('.remove-btn')).getAttribute('field-name');
            this.fields[fieldName] = null;
            if(this.formData) {
                this.fields['remove_' + fieldName] = true;
            }
        },
        clickSubmitBtn() {
            var self = this;
            let submitBtns = document.getElementsByClassName('submit-btn');
            if (submitBtns.length > 0) {
                for (let i = 0; i < submitBtns.length; i++) {
                    const btn = submitBtns[i];
                    btn.addEventListener('click', function () {
                        self.submit();
                        this.disabled = true;
                        let formLanguages = document.querySelectorAll(".tab-content form");
                        formLanguages.forEach(function (form) {
                            var formData = new FormData(form);
                            axios.post(form.action, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            })
                            .then(response => {})
                            .catch(error => {
                                btn.disabled = false;
                            });
                        });
                    });
                }
            }
        },
        uploadBanner(e) {
            const file = e.target.files[0];

            if (!file || !file.type.match(/.(jpg|jpeg|png)$/i)) return;

            let previewBanner = document.getElementById("preview-banner");
            previewBanner.src = URL.createObjectURL(file);
            this.fields.banner = file;
            this.fields.remove_banner = false;
        },
        removeBanner() {
            this.$refs.banner.src = "/img/no-image.jpg";
            this.fields.banner = null;
            if(this.formData) {
                this.fields.remove_banner = true;
            }
        },
    },
    watch: {
        'fields.mapbox_token': function (newVal) {
            this.checkAccessToken(newVal);
        },
        selectMapStyle(newVal) {
            this.fields.style = this.mapStyles[newVal];
        }
    },
    created() {
        if (this.formData) {
            this.fetch(this.formData);
        } else {
            this.selectMapStyle = this.mapStyles.streets;
        }
    },
    mounted() {
        this.clickSubmitBtn();
    },
};
</script>
<style>
.code-textarea {
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    white-space: pre;
    background-color: #f5f5f5;
    color: #2d2d2d;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    padding: .75rem;
    overflow-y: auto;
    resize: vertical;
    min-height: 120px!important;
}
.w-fit{
    width: fit-content;
}
</style>
